export const PROJECT_TABS = [
  { key: "media", label: "Media" },
  { key: "screenshots", label: "Screenshots" },
  { key: "finishes", label: "Finishes" },
];

// Every entry point opens on Media — it is the project's front page, and the
// screenshots/finishes tabs are a post-session library. ?tab= overrides.
export function defaultTab({ tabParam }) {
  return PROJECT_TABS.some((t) => t.key === tabParam) ? tabParam : "media";
}
